export const getMiddle = (min: number, max: number): number => (min + max) / 2;
